module.exports = __webpack_public_path__ + "5dba98aa1fa20cca924130703992910b.png";